import styled from 'styled-components';

const PageContainer = styled.div`
`;

export const GalleryPage = () => {
  return (
	<PageContainer />
  );
};

export default GalleryPage;
